import { render, staticRenderFns } from "./LocationMovementsHistoryTable.vue?vue&type=template&id=d5fa12f8&scoped=true&"
import script from "./LocationMovementsHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./LocationMovementsHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./LocationMovementsHistoryTable.vue?vue&type=style&index=0&id=d5fa12f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fa12f8",
  null
  
)

export default component.exports